import { configureStore, type Middleware } from '@reduxjs/toolkit'
import { guardEncounterWrite, isEncounterWriteLocked, isEncounterWriteReduxAction } from '@util'
import { persistReducer, persistStore, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import rootReducer from './reducers'

const persistConfig = {
  key: 'user',
  storage,
  whitelist: ['user']
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

const encounterWriteGuardMiddleware: Middleware = () => next => action => {
  const typedAction = action as { type?: string }
  if (typedAction?.type && isEncounterWriteReduxAction(typedAction.type) && isEncounterWriteLocked()) {
    guardEncounterWrite()
    return undefined
  }
  return next(action)
}

const store = configureStore({
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER]
      }
    }).concat(encounterWriteGuardMiddleware),
  reducer: persistedReducer
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof rootReducer>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

export default store
export const persistor = persistStore(store)
